
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-delivery/reporting",
      function () {
        return require("private-next-pages/native-delivery/reporting.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-delivery/reporting"])
      });
    }
  